module.exports = __webpack_public_path__ + "img/layer_blue.5b8c9a7e.png";